import { useNavigate } from 'react-router'

import { NotFoundView } from 'features/not-found/components/NotFoundView'

type NotFoundProps = {
  fullHeight?: 'container' | 'viewport'
  onBackToHome?: () => void
}

/**
 * App-wide 404 page. Use for unknown routes, disabled features, or missing resources.
 * Defaults to navigating to "/" when "Back to Home" is clicked. Pass onBackToHome
 * when the caller has project (or other) context and wants a different target.
 */
export const NotFound: React.FC<NotFoundProps> = ({
  fullHeight = 'viewport',
  onBackToHome,
}) => {
  const navigate = useNavigate()
  const handleBack = onBackToHome ?? (() => navigate('/'))
  return <NotFoundView fullHeight={fullHeight} onBackToHome={handleBack} />
}
